"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Select;
exports.MappedSelect = MappedSelect;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _formik = require("formik");

var _Select = require("./Select.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Select(_ref) {
  var label = _ref.label,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      multiple = _ref.multiple,
      tip = _ref.tip,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
      variant = _ref.variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#255915" : _ref$color,
      background = _ref.background,
      other = _objectWithoutProperties(_ref, ["label", "options", "multiple", "tip", "defaultValue", "variant", "color", "background"]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Select.SelectView, {
    background: background,
    color: color,
    variant: variant
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "select-wrapper"
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "select-label"
  }, label), /*#__PURE__*/_react.default.createElement(_core.Select, _extends({
    className: "select",
    disableUnderline: true,
    multiple: multiple,
    defaultValue: defaultValue,
    inputProps: {
      "data-testid": "select"
    }
  }, other), options.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: value,
      value: value,
      children: label
    });
  })))), tip && /*#__PURE__*/_react.default.createElement("div", null, tip));
}

function MappedSelect(props) {
  var errorStyle = {
    color: "red"
  };

  function getTip() {
    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var tip = arguments.length > 1 ? arguments[1] : undefined;

    if (meta.touched && meta.error && _typeof(meta.error) !== "object") {
      return /*#__PURE__*/_react.default.createElement("span", {
        style: errorStyle
      }, meta.error);
    }

    if (tip) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "tip"
      }, tip);
    }
  }

  var _useField = (0, _formik.useField)(props.name),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-grp"
  }, /*#__PURE__*/_react.default.createElement(Select, _extends({}, field, props, {
    tip: getTip(meta, props.tip)
  })));
}

//# sourceMappingURL=Select.js.map